<template>
  <div>
    <v-btn dark class="btn" :style="{background: color, padding:padding}"><v-icon :style="{padding:padding}">{{icon}}</v-icon>{{msg}}</v-btn>
  </div>
</template>

<script>
export default {
  // props: ['icon', 'msg', 'background']
  props: {
    icon: String,
    color: String,
    msg: String,
    padding: String
  }
}
</script>
<style scoped>
    .btn {
        border-radius: 20px;
        width: 327px;
        height: 24px;
    }
</style>



// WEBPACK FOOTER //
// src/components/V2LOYALTY_REDESIGN/MyComponent.vue